import { render, staticRenderFns } from "./PayDirect.vue?vue&type=template&id=16ac2bc2&scoped=true"
import script from "./PayDirect.vue?vue&type=script&lang=js"
export * from "./PayDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac2bc2",
  null
  
)

export default component.exports